import { put, take, takeEvery, all, fork } from "redux-saga/effects"
import { push } from "connected-react-router"
// api
// import * as findPwApi from "../../api/auth/findPw"
// actions
import * as findPwActions from "../../modules/auth/findPw"
import * as loadingActions from "../../modules/common/loading"
import * as certActions from "../../modules/auth/cert"
// import * as dialogActions from "../../modules/common/dialog"

function* findPw({ userCert }) {

  // 1. loading OPEN
  yield put(loadingActions.setLoading(true))

  // 2. 인증 확인 요청
  yield put(certActions.certConfirmRequest(userCert, false, true))
  const certConfirmResult = yield take([certActions.CERT_CONFIRM_SUCCESS, certActions.CERT_CONFIRM_FAIL])
  if (certConfirmResult.type === certActions.CERT_CONFIRM_SUCCESS) {

    // 비밀번호 재설정 화면에 계정과 인증 토큰을 함께 넘긴다 (토큰 없이는 서버가 변경을 거부)
    yield put(push("/resetpw", { simpleId: userCert.simpleId, certToken: certConfirmResult.certToken }))

  } else if (certConfirmResult.type === certActions.CERT_CONFIRM_FAIL) {
    yield put(findPwActions.findPwFail())
  }

  // 4. loading CLOSE
  yield put(loadingActions.setLoading(false))


}

function* findPwWatch() {
  yield takeEvery(findPwActions.FIND_PW_REQUEST, findPw)
}

export default function* findPwSaga() {
  yield all([
    fork(findPwWatch),
  ])
}
